import { Command } from 'ckeditor5'
import sanitizeHtml from 'sanitize-html'

export class CutCommand extends Command {
  async execute() {
    const model = this.editor.model
    const selection = model.document.selection

    if (selection.isCollapsed) {
      return
    }

    // Get selected content
    const selectedContent = model.getSelectedContent(selection)

    // Convert to view fragment
    const viewFragment = this.editor.data.toView(selectedContent)

    // Convert view to HTML string using data processor
    const clipboardHtml = this.editor.data.processor.toData(viewFragment)

    // Copy to clipboard
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([clipboardHtml], { type: 'text/html' }),
            'text/plain': new Blob(
              [
                sanitizeHtml(clipboardHtml, {
                  allowedTags: [],
                  allowedAttributes: {},
                }),
              ],
              {
                type: 'text/plain',
              }
            ),
          }),
        ])
      } catch (error) {
        console.warn('Failed to copy to clipboard:', error)
      }
    }

    // Delete selected content
    model.deleteContent(selection)
  }

  refresh() {
    const selection = this.editor.model.document.selection
    this.isEnabled = !selection.isCollapsed
  }
}
